import React, { useMemo } from 'react'
import PropTypes from 'prop-types'
import { push } from '@lagunovsky/redux-react-router'
import { useDispatch } from 'react-redux'
import { useLocation } from 'react-router'
import { darkBlue } from 'utils/constants/ColorTheme'
import { Icon, Tooltip, Grid2, Typography } from '@mui/material'

// const $ = window.$

const SlideNavLink = ({
    id = '',
    href = '',
    name = '',
    className = '',
    icon = '',
    tooltip = true,
    external = false,
    'data-cy': dataCy = '',
}) => {
    const dispatch = useDispatch()
    const { pathname } = useLocation()

    const isSelected = useMemo(() => {
        if (external) return false
        if (href === '/') {
            return pathname === href
        }
        return pathname.startsWith(href)
    }, [pathname, href, external])

    return (
        <li className={className} style={{ padding: '5px' }}>
            <Tooltip disableHoverListener={!tooltip} title={name} placement='right'>
                <Grid2
                    onClick={() => external ? window.open(href, 'blank') : dispatch(push(href))}
                    data-cy={dataCy}
                    sx={{
                        height: '30px',
                        padding: '0 10px',
                        cursor: 'pointer',
                        borderRadius: '10px',
                        backgroundColor: isSelected ? 'lightgrey' : 'white',
                        '&:hover': {
                            backgroundColor: 'lightgrey',
                        },
                    }}
                    container
                    alignItems='center'
                    justifyContent='flex-start'
                >
                    {!!icon && <Icon id={id} sx={{ fontSize: '24px', marginRight: '5px', color: isSelected ? darkBlue : 'grey' }}>{icon}</Icon>}
                    <Typography
                        fontSize='14px'
                        color='black'
                        noWrap
                        width='170px'
                    >{name}</Typography>
                </Grid2>
            </Tooltip>
        </li>
    )
}

SlideNavLink.propTypes = {
    id: PropTypes.string,
    href: PropTypes.string.isRequired,
    name: PropTypes.string,
    className: PropTypes.string,
    icon: PropTypes.string,
    external: PropTypes.bool,
    tooltip: PropTypes.bool,

    'data-cy': PropTypes.string,
}

export default SlideNavLink